__webpack_require__.p = "/marvel-info-portal/";